/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PairingCompletionError { 
    /**
     * A single ASCII error code from the following. * authorization_pending - The authorization request is still pending as the end user hasn\'t yet completed the user-interaction steps. * slow_down - A variant of \"authorization_pending\", the authorization request is still pending and polling should continue, but the polling interval must be increased by 5 seconds for this and all subsequent requests. * access_denied -  The authorization request was denied. * expired_token - The \"device_code\" has expired, and the device authorization session has concluded. * invalid_request - The request is missing a required parameter, includes an unsupported parameter value (other than grant type), or is otherwise malformed. * unsupported_grant_type - The authorization grant type is not supported by the authorization server.
     */
    error: PairingCompletionError.ErrorEnum;
}
export namespace PairingCompletionError {
    export type ErrorEnum = 'authorization_pending' | 'slow_down' | 'access_denied' | 'expired_token' | 'invalid_request' | 'unsupported_grant_type';
    export const ErrorEnum = {
        AUTHORIZATION_PENDING: 'authorization_pending' as ErrorEnum,
        SLOW_DOWN: 'slow_down' as ErrorEnum,
        ACCESS_DENIED: 'access_denied' as ErrorEnum,
        EXPIRED_TOKEN: 'expired_token' as ErrorEnum,
        INVALID_REQUEST: 'invalid_request' as ErrorEnum,
        UNSUPPORTED_GRANT_TYPE: 'unsupported_grant_type' as ErrorEnum
    };
}


